// ----------------------------------------------------------------------
export function card(theme) {
    return {
        MuiCard: {
            styleOverrides: {
                root: {
                    position: "relative",
                    boxShadow: 'none',
                    borderRadius: theme.shape.borderRadius * 2,
                    zIndex: 0, // Fix Safari overflow: hidden with border radius
                    padding: "8px 12px",
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: "0px",
                    // padding: theme.spacing(1, 1.5, 1, 1.5),
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: "0px",
                    // padding: theme.spacing(1)
                },
            },
        },
    };
}
